module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_steinen-572ab7263bf5e4e740a58f58740fd65f.png";